// Loads the section-based size-guide page content into the PDP "Size guide" popup modal.
// The Dawn popup renders page.content (the admin body), but the size-guide page builds its
// content from a section, so we fetch the page and inject its .size-guide element once.
(function () {
  function load(container) {
    if (!container || container.dataset.loaded) return;
    const url = container.dataset.sizeGuideUrl;
    if (!url) return;
    container.dataset.loaded = '1';

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('.size-guide');
        if (content) {
          container.innerHTML = '';
          container.appendChild(content);

          // Wire the section's own close (×) to the modal.
          const closeBtn = content.querySelector('[data-size-guide-close]');
          const modal = container.closest('modal-dialog');
          if (closeBtn && modal) {
            closeBtn.addEventListener('click', () => modal.hide());
          }

          // Move the selected-variant image (rendered hidden alongside the modal
          // content) directly below the size-guide diagram.
          const variantImage = modal?.querySelector('size-guide-variant-image');
          const diagram = content.querySelector('.size-guide__diagram');
          if (variantImage && diagram) {
            diagram.insertAdjacentElement('afterend', variantImage);
            variantImage.removeAttribute('hidden');
          }
        }
      })
      .catch((error) => {
        container.dataset.loaded = '';
        console.error('Size guide popup failed to load', error);
      });
  }

  function init() {
    document.querySelectorAll('[data-size-guide-url]').forEach(load);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
